// The admin service's codes in desyr's words (27-admin.md, Texts; 94-services-api.md, "Every error
// code"): an area's own sentence where 27 gives one, else the shared plain words of 02.
import { describe, type Context } from '../core/errors';
import { t, type Key } from '../i18n';

const WORDS: Record<string, Key> = {
  'desyr.company.no_domain': 'admin.noDomain',
  'desyr.people.name_needed': 'admin.nameNeeded',
  'desyr.people.no_such_domain': 'admin.noSuchDomain',
  'desyr.people.name_in_use': 'admin.nameInUse',
  'desyr.people.name_taken': 'admin.nameTaken',
  'desyr.people.already_set_up': 'admin.alreadySetUp',
  'desyr.people.own_role': 'admin.ownRole',
  'desyr.people.yourself': 'admin.yourself',
  'desyr.people.chat_step_failed': 'admin.chatStepFailed',
  'desyr.people.chat_still_open': 'admin.chatStillOpen',
  'desyr.password.too_short': 'admin.tooShort',
  'desyr.password.wrong': 'admin.wrongPassword',
  'desyr.link.not_valid': 'admin.linkNotValid',
  'desyr.link.in_use': 'admin.linkInUse',
  'desyr.email.not_an_address': 'admin.notAnAddress',
  'desyr.recovery.company_address': 'admin.companyAddress',
  'desyr.recovery.wrong_code': 'admin.wrongCode',
  'desyr.mail.refused': 'admin.mailRefused',
};

/** The words for a failure of the admin service (`own` first: a form's own sentence by code). */
export const adminWords = (error: unknown, context: Context = 'general', own: Record<string, string> = {}) =>
  describe(error, context, (_kind, answer) => (answer.code ? (own[answer.code] ?? (WORDS[answer.code] && t(WORDS[answer.code]))) : undefined)).text;
